import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../../core/utils';
import { selectUserBapInteractions, userInteractedWithBap, } from '../../../core/reducers/savedBuild';
const useBapRegisterUserInteraction = (interactionScope) => {
    const dispatch = useAppDispatch();
    const userInteractions = useAppSelector(selectUserBapInteractions);
    const onUserInteraction = useCallback(() => {
        if (!interactionScope || (interactionScope && (userInteractions === null || userInteractions === void 0 ? void 0 : userInteractions[interactionScope])))
            return;
        dispatch(userInteractedWithBap({ [interactionScope]: true }));
    }, [dispatch, interactionScope, userInteractions]);
    return {
        userInteractedWith: userInteractions !== null && userInteractions !== void 0 ? userInteractions : {},
        registerUserInteraction: onUserInteraction,
    };
};
export default useBapRegisterUserInteraction;
